<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>

    <div class="vx-row flex w-full">

      <!-- LEFT SIDE -->
      <div class="vx-col w-full lg:w-3/5 sm:w-full">

        <!-- SUBJECT INFO -->
        <subject-info :class-room="classRoom"/>
        <!-- INSTRUCTION INFO -->
        <introduction-info :class-room="classRoom"/>

        <!-- COURSE OUTLINE UNITS INFO -->
        <course-outline-unit-info :class-room="classRoom"/>

      </div>

      <!-- RIGHT SIDE -->
      <div class="vs-col lg:w-2/5">

        <!-- TEACHER INFO -->
        <teacher-info :class-room="classRoom"/>

        <!-- ASSESSMENT EDIT -->
        <assessment-info :class-room="classRoom"/>

        <!-- CLASS ASSIGNMENT EDIT -->
        <class-assignment-edit :class-room="classRoom"/>

        <!-- CLASS MATERIAL EDIT -->
        <class-material-edit :class-room="classRoom"/>


      </div>
    </div>

  </div>
</template>

<script>
  import {state} from './data';
  import SubjectInfo from './Components/SubjectInfo'
  import IntroductionInfo from './Components/IntroductionInfo'
  import CourseOutlineUnitInfo from './Components/CourseOutlineUnitInfo'
  import TeacherInfo from './Components/TeacherInfo'
  import AssessmentInfo from './Components/AssessmentInfo'
  import ClassAssignmentEdit from './Components/ClassAssignmentEdit'
  import ClassMaterialEdit from './Components/ClassMaterialEdit'

  import ClassRoom from '@/store/modules/class-room/class-room/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.ClassRoom) state.registerModule(`ClassRoom`, ClassRoom);

  const {
    mapActions: mapClassRoomActions,
  } = createNamespacedHelpers(`ClassRoom`);


  const {
    mapFields: mapClassRoomFields,
  } = createHelpers({
    getterType: `ClassRoom/getField`,
    mutationType: `ClassRoom/updateField`,
  });

  export default {
    pros:{
      classRoomId:{
        type: String,
        require: true,
      }
    },
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      SubjectInfo,
      IntroductionInfo,
      CourseOutlineUnitInfo,
      TeacherInfo,
      AssessmentInfo,
      ClassAssignmentEdit,
      ClassMaterialEdit
    },
    data() {
      return {
        state: state,
        store: state.store,
        local: state.local,
      }
    },
    computed: {
      ...mapClassRoomFields({classRoomProcessing: 'processing',classRoomSuccess: 'success',classRoomError: 'error',}),
      classRoom() {
        return this.local.classRoom;
      },
    },
    watch: {
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassRoomActions({
        getClassRoom: 'getClassRoom',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//


      //---------------------------------------- Local Function ------------------------------------------------------//

      async loadData() {
        let result = await this.getClassRoom({id: this.$route.params.classRoomId});
        if(result){
          this.local.classRoom = JSON.parse(JSON.stringify(result))
        }
      },
    },
    async created() {
      await this.loadData();
    },
  }

</script>


<style lang="scss">

</style>

